<!--P064、P066-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'RequirePriceManage'})">要货调价查询</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">要货调价详情</div>
    </div>
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">要货调价单详情</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">要货调价单号</div>
      <div class="cs_radius_lg txt_info_search">{{detailInfo.num}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">制单人</div>
      <div class="cs_radius_lg txt_info_search">{{detailInfo.staffName}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">制单日期</div>
      <div class="cs_radius_lg txt_info_search">{{detailInfo.date}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">配送中心</div>
      <div class="cs_radius_lg txt_info_search width_240">{{detailInfo.dcName}}</div>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">生效时间</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm ui_margin_left_44" style="padding-right: 0">{{detailInfo.cstEffect}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">状态</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm ui_margin_left_30">{{PRICE_MANAGE_STATUS[detailInfo.orderStatus]}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">备注</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm ui_margin_left_44 width_508">{{detailInfo.remarks}}</div>
    </div>
    <div class="cs_margin_top div_search_result cs_padding_top">
      <div class="div_search">
        <div class="cs_title_primary cs_text_default type_info_search">调价门店</div>
      </div>
      <div class="div_table cs_margin_top_xs">
        <table class="cs_table cs_td_divider_none cs_thead_fixed" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="400px">门店编号</th>
            <th width="100%">门店名称</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in shopList">
            <td width="40px">{{index+1}}</td>
            <td width="400px">{{item.shopId}}</td>
            <td width="100%">{{item.shopName}}</td>
          </tr>
          <template v-if="PAGE_SIZE>shopList.length">
            <tr v-for="(item,index) in (PAGE_SIZE-shopList.length)">
              <td width="40px"></td>
              <td width="400px"></td>
              <td width="100%"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div class="div_search cs_margin_top_sm">
        <div class="cs_title_primary cs_text_default type_info_search">调价货品</div>
      </div>
      <div class="div_table cs_margin_top_xs">
        <table class="cs_table cs_td_divider_none cs_thead_fixed" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="151px">货品编号</th>
            <th width="280px">货品名称</th>
            <th width="100px">规格</th>
            <th width="130px">库存单位</th>
            <th width="184px">调前配送价</th>
            <th width="184px">调后配送价</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList">
            <td width="40px">{{index+1}}</td>
            <td width="151px">{{item.materialNum}}</td>
            <td width="280px">{{item.materialName}}</td>
            <td width="100px">{{item.materialSpecs}}</td>
            <td width="130px">{{item.units}}</td>
            <td width="184px">{{item.oldPrice}}</td>
            <td width="184px">{{item.newPrice}}</td>
          </tr>
          <template v-if="PAGE_SIZE>orderList.length">
            <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
              <td width="40px"></td>
              <td width="151px"></td>
              <td width="280px"></td>
              <td width="100px"></td>
              <td width="130px"></td>
              <td width="184px"></td>
              <td width="184px"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div v-show="detailInfo.orderStatus===1" class="div_operation_table cs_margin_top_sm">
        <button @click="btnCancel" class="cs_btn_dialog ui_btn_blue cs_fr"
                type="button">作废
        </button>
      </div>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  import {PRICE_MANAGE_STATUS} from "../../assets/utils/constants"
  export default {
    name: "RequirePriceDetail",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        detailInfo:{
          num:"",
          staffName:"",
          date:"",
          dcName:"",
          remarks:"",
          cstEffect:"",
          orderStatus: "",
        },
        orderList: [],
        shopList: [],
        PRICE_MANAGE_STATUS: PRICE_MANAGE_STATUS,
        PAGE_SIZE:10
      }
    },
    created: function () {
      this.showDetail();
    },
    mounted: function() {
    },
    methods: {
      showDetail(){
        this.$ajax.priceManage.acquireRequirePriceManage.bind(this)(this.$route.query.id,(data) => {
          this.detailInfo={
            num: data.data.order.num,
            staffName: data.data.order.staffName,
            date: this.isEmpty(data.data.order.cstCreate)?"":data.data.order.cstCreate.substring(0,10),
            dcName: data.data.order.dcName,
            remarks: data.data.order.remarks,
            cstEffect: data.data.order.cstEffect,
            orderStatus: data.data.order.orderStatus,
          };
          this.orderList = data.data.list;
          this.shopList = data.data.order.appendices
        }, (data) => {
        }, true)
      },
      btnCancel(){
        this.$alert("确认作废该要货调价单吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.priceManage.cancelRequirePriceManage.bind(this)(this.$route.query.id, (data) => {
              this.showDetail();
            }, (data) => {
            }, true)
          }
        }, true);
      },

      failDefault() {
      },
    },
  }
</script>

<style scoped>
  .width_508{width: 508px;}
  .width_240{width: 240px;}
  .cs_table tbody{max-height: 411px;}
</style>



// WEBPACK FOOTER //
// src/page/price/RequirePriceDetail.vue